import { SOCIAL_PROVIDERS } from "./pd-socialmedia-model.js";
import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { LitElement, css, html, nothing } from "lit";
import { property, query, state } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import "@progressive-development/pd-icon/pd-icon";
import "@progressive-development/pd-forms/pd-suggestion-box";
import "@progressive-development/pd-forms/pd-form-row";
import "@progressive-development/pd-forms/pd-button";
import "@progressive-development/pd-forms/pd-input";
import { pdIcons } from "@progressive-development/pd-icon";
import { brandIconMap, defaultBrandIcon } from "@progressive-development/pd-icon-brands";
//#region src/pd-socialmedia/PdSocialmedia.ts
var PdSocialmedia = class PdSocialmedia extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.summary = false;
		this.initItems = [];
		this.providers = SOCIAL_PROVIDERS;
		this.showLabelBelowIcon = false;
		this.openLinksInSameTab = false;
		this._pendingAddProvider = null;
		this._currentInputValue = null;
		this._editItems = [];
		this._openAddSuggestItem = (e) => {
			const metaProvider = e.detail;
			if (!metaProvider?.id) return;
			this._pendingAddProvider = metaProvider;
			this._currentInputValue = null;
		};
		this._closeAddSuggestedItem = (_e) => {
			this._pendingAddProvider = null;
			this._currentInputValue = null;
		};
	}
	static {
		this.styles = css`
    :host {
      display: block;
    }

    /* View: icons row */
    .view-list {
      display: flex;
      flex-wrap: wrap;
      gap: var(--pd-gap, 0.5rem);
      align-items: center;
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .view-list li:hover .icon-tile .icon-label {
      color: var(--pd-default-hover-col);
    }

    .icon-tile {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.25rem;
      padding: 0.25rem;
      min-width: 2.25rem;
    }

    .brand-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 1.5em;
      height: 1.5em;
      color: var(--pd-sc-icon-col, var(--pd-default-col));
    }

    .brand-icon svg {
      width: 100%;
      height: 100%;
    }

    .icon-tile a,
    .icon-tile button[role="link"] {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      outline: none;
      border: none;
      background: none;
      cursor: pointer;
    }

    .icon-label {
      font-size: 0.75rem;
      line-height: 1;
      color: var(--pd-sc-text-muted, var(--pd-default-disabled-col));
      text-align: center;
      max-width: 6rem;
    }

    /* Edit: list */
    .edit {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .edit-list {
      display: flex;
      flex-direction: column;
      gap: 0.1rem;
    }

    .row {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      gap: 0;
      padding: 0 var(--pd-spacing-xs);
      border-radius: var(--pd-radius-md);
      max-width: 500px;
    }

    .edit-list > .row:nth-child(odd) {
      background: var(--pd-sc-row-bg-odd-col, var(--pd-default-bg-light-col));
    }

    .edit-list > .row:nth-child(even) {
      background: var(--pd-sc-row-bg-even-col, var(--pd-default-bg-dark-col));
    }

    .edit-list > .row:hover {
      background: var(--pd-sc-row-bg-col-hover, var(--pd-default-lightest-col));
    }

    .provider {
      font-family: var(--pd-default-font-title-family);
      color: var(--pd-sc-edit-provider-col, var(--pd-default-font-title-col));
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      min-width: 10rem;
    }

    .value {
      font-family: var(--pd-default-font-input-family);
      font-size: 0.95rem;
      color: var(--pd-sc-edit-value-col, var(--pd-default-font-input-col));
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .btn-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      border: none;
      background: none;
      border-radius: 0.5rem;
      cursor: pointer;
    }

    .btn-icon:hover {
      background: var(--pd-surface-200, rgba(0, 0, 0, 0.05));
    }

    .danger {
      --pd-icon-col: var(--pd-default-error-col, #c0392b);
    }

    .btn-icon:focus-visible {
      outline: 2px solid var(--pd-focus-ring-col, var(--pd-default-col));
      outline-offset: 2px;
    }

    .current-input-url {
      color: var(--pd-sc-text-muted, var(--pd-default-disabled-col));
      padding-top: 0.2rem;
      font-size: 1rem;
    }

    .add-button-group {
      padding-top: 0.5rem;
      --pd-button-font-size: 1rem;
    }
  `;
	}
	willUpdate(_changedProperties) {
		if (_changedProperties.has("initItems")) this._editItems = [...this.initItems || []];
	}
	addItem(entry) {
		const next = [...this._editItems, entry];
		this._editItems = next;
		this.emitChange();
	}
	removeIndex(index) {
		const next = this._editItems.slice();
		next.splice(index, 1);
		this._editItems = next;
		this.emitChange();
	}
	get value() {
		return this._editItems;
	}
	render() {
		return this.summary ? this.renderView() : this.renderEdit();
	}
	renderView() {
		const items = this._editItems ?? [];
		const empty = items.length === 0;
		return html`
      <ul
        class="view-list"
        aria-label="${msg("Social-Media-Profile", { id: "pd.socialmedia.aria.label" })}"
      >
        ${empty ? html`<li>
                <span
                  >${msg("Keine Einträge", { id: "pd.socialmedia.empty" })}</span
                >
              </li>` : items.map((item) => {
			const provider = this._findProvider(item.providerId);
			const label = provider?.label ?? item.label ?? item.providerId;
			const href = this._toUrl(provider, item.value);
			const title = `${label}: ${href}`;
			const content = html`
                  <div class="icon-tile" title=${title}>
                    ${this._renderIcon(provider)}
                    ${this.showLabelBelowIcon ? html`<div class="icon-label">${label}</div>` : nothing}
                  </div>
                `;
			return html` <li>
                  ${href ? html` <a
                          href=${href}
                          target=${this.openLinksInSameTab ? "_self" : "_blank"}
                          rel="noopener noreferrer"
                          aria-label=${label}
                          >${content}</a
                        >` : html`<div class="icon-tile" aria-label=${label}>
                          ${content}
                        </div>`}
                </li>`;
		})}
      </ul>
    `;
	}
	renderEdit() {
		return html`
      <div class="edit">
        <div>
          <pd-form-row>
            <pd-suggestion-box
              id="suggesBoxId"
              span="full"
              label="${msg("Neuer Eintrag", { id: "pd.socialmedia.new.entry" })}"
              minCharsToSearch="1"
              placeholder="${msg("Socialmedia eingeben...", { id: "pd.socialmedia.placeholder" })}"
              .callFunction="${this._searchSocialProviders.bind(this)}"
              @element-selected="${this._openAddSuggestItem}"
              @element-unselected="${this._closeAddSuggestedItem}"
              @pd-form-element-change="${(e) => e.stopPropagation()}"
              @pd-form-element-register="${(e) => e.stopPropagation()}"
              @pd-form-element-unregister="${(e) => e.stopPropagation()}"
            ></pd-suggestion-box>
          </pd-form-row>
          ${this._pendingAddProvider !== null ? this._renderAddRow() : ""}
        </div>

        <div class="edit-list">
          ${this._editItems?.map((item, i) => {
			const meta = this._findProvider(item.providerId);
			const label = meta?.label ?? item.providerId;
			return html`
              <div class="row">
                <div class="provider">
                  ${this._renderIcon(meta)}<span>${label}</span>
                </div>
                <div class="value">${item.value}</div>
                <button
                  class="btn-icon danger"
                  @click=${() => this.removeIndex(i)}
                  aria-label="${msg("Eintrag löschen", { id: "pd.socialmedia.delete" })}"
                >
                  <pd-icon icon="${pdIcons.ICON_DELETE_NEW}"></pd-icon>
                </button>
              </div>
            `;
		})}
        </div>
      </div>
    `;
	}
	_renderAddRow() {
		const provider = this._pendingAddProvider;
		if (!provider) return html`<p>! Missing Provider !</p>`;
		return html`
      <pd-form-row class="no-padding">
        <pd-input
          id="scValueId"
          maxlength="250"
          span="full"
          label="${provider.label}"
          helperTxt="${`Pattern: ${provider.pattern}`}"
          placeholder="${provider.placeholder || `Eingabe ${provider.inputKind}`}"
          valueName="providerValue"
          @pd-form-element-change="${(e) => {
			this._currentInputValue = e.detail.value;
			e.stopPropagation();
		}}"
          @pd-form-element-register="${(e) => e.stopPropagation()}"
          @pd-form-element-unregister="${(e) => e.stopPropagation()}"
          required
        ></pd-input>
      </pd-form-row>
      <div class="current-input-url">
        URL:
        <a
          target="_blank"
          href="${this._toUrl(provider, this._currentInputValue || "") || ""}"
          >${this._toUrl(provider, this._currentInputValue || "")}</a
        >
      </div>

      <div class="add-button-group">
        <pd-button
          icon="${pdIcons.ICON_CLOSE}"
          text="${msg("Abbrechen", { id: "pd.socialmedia.cancel" })}"
          @button-clicked="${() => {
			this._currentInputValue = null;
			this._pendingAddProvider = null;
			this._suggestForm?.reset();
		}}"
        ></pd-button>
        <pd-button
          icon="${pdIcons.ICON_SYNC}"
          text="${msg("Speichern", { id: "pd.socialmedia.save" })}"
          @button-clicked="${() => {
			this.addItem({
				providerId: this._pendingAddProvider?.id || "",
				value: this._currentInputValue || ""
			});
			this._currentInputValue = null;
			this._pendingAddProvider = null;
			this._suggestForm?.reset();
		}}"
        ></pd-button>
      </div>
    `;
	}
	async _searchSocialProviders(input) {
		const includedIds = this._editItems.map((item) => item.providerId);
		return Promise.resolve(SOCIAL_PROVIDERS.filter((v) => !includedIds.includes(v.id) && (v.label.toLowerCase().includes(input.toLowerCase()) || v.category.toLowerCase().includes(input.toLowerCase()) || v.aliases?.join()?.toLowerCase().includes(input.toLowerCase()))).map((e) => ({
			id: e.id,
			name: e.label || "--",
			subInfo: html`<b><em>${e.category || "--"}:</em></b> ${e.aliases?.join(",") || e.id}`,
			objectValue: e
		})));
	}
	_renderIcon(provider) {
		const icon = (provider ? brandIconMap.get(provider.id) : void 0) ?? defaultBrandIcon;
		return html`<span class="brand-icon">${icon}</span>`;
	}
	_findProvider(id) {
		if (!id) return void 0;
		return this.providers?.find((p) => p.id === id);
	}
	_toUrl(meta, raw) {
		const v = raw?.trim();
		if (!v) return null;
		if (meta?.toUrl) return meta.toUrl(v);
		if (/^https?:\/\//i.test(v)) return v;
		return null;
	}
	emitChange() {
		this.dispatchEvent(new CustomEvent("items-change", {
			detail: { items: this._editItems },
			bubbles: true,
			composed: true
		}));
	}
};
__decorate([property({
	type: Boolean,
	reflect: true
})], PdSocialmedia.prototype, "summary", void 0);
__decorate([property({ type: Array })], PdSocialmedia.prototype, "initItems", void 0);
__decorate([property({ type: Array })], PdSocialmedia.prototype, "providers", void 0);
__decorate([property({ type: Boolean })], PdSocialmedia.prototype, "showLabelBelowIcon", void 0);
__decorate([property({ type: Boolean })], PdSocialmedia.prototype, "openLinksInSameTab", void 0);
__decorate([state()], PdSocialmedia.prototype, "_pendingAddProvider", void 0);
__decorate([state()], PdSocialmedia.prototype, "_currentInputValue", void 0);
__decorate([state()], PdSocialmedia.prototype, "_editItems", void 0);
__decorate([query("#suggesBoxId")], PdSocialmedia.prototype, "_suggestForm", void 0);
PdSocialmedia = __decorate([localized()], PdSocialmedia);
//#endregion
export { PdSocialmedia };
